module.exports = __webpack_public_path__ + "img/syringe.3140aff9.png";